import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import {
  fireToastError,
  fireToastSuccess,
  fireToastWarning,
} from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import fetchBookingSettings from '../../models/Integration/fetchBookingSettings'
import fetchBookingRooms from '../../models/Integration/fetchBookingRooms'
import saveBookingMappings from '../../models/Integration/saveBookingMappings'
import {
  getBookingCurrency,
  getBookingMapping,
  getBookingRooms,
  getBookingSettings,
} from '../../reducers/booking/selectors'
import startBookingSync from '../../models/Integration/startBookingSync'
import confirmBookingConfiguration from '../../models/Integration/confirmBookingConfiguration'
import { getPriceConfig, getPrices } from '../../reducers/price/selectors/price'
import {
  getUserCurrency,
  getUserObjectId,
} from '../../reducers/userObject/selectors/object'
import { isAfter, isBefore, isSameDay } from 'date-fns'
import requestSaveObject from '../../actions/userObject/profile/requestUpdateUserProfile'
import {
  getIsMultiPriceEnabled,
  getUserProfile,
} from '../../reducers/userObject/selectors/settings'
import { getCurrency } from '../../reducers/currency/selectors/currency'
import sendErrorMessage from '../../models/User/sendErrorMessage'
import { withoutRemovedRooms } from '../../reducers/bookingCalendar/selectors/rooms'
import validateBooking from '../../models/Integration/validateBooking'
import settings from '../../actions/toasts/icons/settings'
import { requestSynchronization } from '../../actions/synchronize/synchronize'
import saveMappingImport from '../../models/Booking/saveMappingImport'
import { getCalendarId } from '../../reducers/bookingCalendar/selectors/calendar'
import { getAccessToken } from '../../reducers/userAccount/selectors/credentials'
import createFetch from '../../models/fetch'
import updatePriceConfigurationFee from '../../models/Price/updatePriceConfigurationFee'
import { PriceConfigurationActions } from '../../reducers/price/actionNames'
import { getConfiguredGlobalBookingPlanRates } from '../../models/Booking/getNewIndependentBookingPlans'
import { normalizeBookingPlanRateValue } from '../../models/Price/groupBookingPlanRatesByName'
import { notifyIntegrationConfigSaved } from '../../utils/notifyIntegrationConfigSaved'

function* setPropertyId(action: any) {
  try {
    const actionNames = fetchActionsName(ActionNames.SetPropertyId)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, sendErrorMessage)),
    ])

    yield call(
      service,
      action.payload.recipient,
      action.payload.subject,
      action.payload.body,
    )
    // yield Effects.put(fireToastSuccess(i18n.t('BED_3197_connect_window_ok')))
    // yield Effects.put({
    //   type: IntegrationAction.SetPropertyIdRedux,
    //   payload: action.payload.booking_id,
    // })
  } catch (e) {
    yield Effects.put(fireToastError(i18n.t('BED_3197_connect_window_error')))
    //console.error(e)
  }
}

// function* setBookingStatus(action: any) {
//   type ReturnSetBookingStatus = IFetchAction<
//     ReturnType<typeof saveBookingStatus>
//   >
//
//   try {
//     const actionNames = fetchActionsName(ActionNames.SetBookingStatus)
//     const [{ service }]: [ReturnSetBookingStatus] = yield all([
//       take(actionNames.output),
//       put(callFetch(actionNames.input, actionNames.output, saveBookingStatus)),
//     ])
//
//     yield call(service, {
//       booking_integration_status: action.payload,
//     })
//     yield Effects.put({
//       type: IntegrationAction.SetBookingStatusRedux,
//       payload: action.payload,
//     })
//   } catch (e) {
//     console.error(e)
//   }
// }

export function* getBookingSettingsSaga(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchBookingSettings)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(actionNames.input, actionNames.output, fetchBookingSettings),
      ),
    ])

    return yield call(service, action.payload)
  } catch (e) {
    //console.error(e)
  }
}

export function* getBookingRoomsSaga(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchBookingRooms)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, fetchBookingRooms)),
    ])

    return yield call(service, action.payload)
    // yield Effects.put({
    //   type: IntegrationAction.SetBookingRoomsRedux,
    //   payload: res,
    // })
  } catch (e) {
    //console.error(e)
  }
}

// function* unconfirmBooking(action) {
//   type ReturnUnconfirmBooking = IFetchAction<
//     ReturnType<typeof unconfirmBookingConfiguration>
//   >
//
//   try {
//     const next = yield* saveConfiguration(action)
//     if (next === false) {
//       return
//     }
//     const actionNames = fetchActionsName(ActionNames.UnconfirmBooking)
//     const [{ service }]: [ReturnUnconfirmBooking] = yield all([
//       take(actionNames.output),
//       put(
//         callFetch(
//           actionNames.input,
//           actionNames.output,
//           unconfirmBookingConfiguration,
//         ),
//       ),
//     ])
//
//     yield call(service)
//     yield Effects.put({
//       type: IntegrationAction.SetBookingStatus,
//       payload: '1',
//     })
//   } catch (e) {
//     console.error(e)
//   }
// }

function* confirmBooking(action) {
  try {
    const next = yield* saveConfiguration(action)
    if (next === false) {
      return
    }
    const actionNames = fetchActionsName(ActionNames.ConfirmBooking)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(
          actionNames.input,
          actionNames.output,
          confirmBookingConfiguration,
        ),
      ),
    ])

    const bookingSettings = yield Effects.select(getBookingSettings)

    if (!action.notNotify) {
      yield Effects.put(fireToastSuccess(i18n.t('BED_3197_synchornization_ok')))
    }
    yield call(
      service,
      bookingSettings.booking_import_reservations,
      bookingSettings.id,
    )
    yield Effects.put({
      type: IntegrationAction.SetBookingStatus,
      payload: '2',
    })
  } catch (e) {
    //console.error(e)
  }
}

function redirect() {
  return () => {
    if ('routerHistory' in window) {
      ;(window as any).routerHistory.push({
        pathname: '/price/configuration',
        state: {
          returnOnSave: '/integration/booking',
        },
      })
    }
  }
}

function* validateBookingSaga(action) {
  const multiPrice = yield Effects.select(getIsMultiPriceEnabled)
  try {
    const actionNames = fetchActionsName(
      ActionNames.ValiateBookingConfiguration,
    )
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, validateBooking)),
    ])

    const resp = yield call(service, action.payload)

    // errorDefaultPrices: 0
    // errorEmptyPrices: 0
    // errorNotFullPrices: 0
    // warningEmptyDates: 0
    // warningRestriction: 1

    const items = resp.items
    if (items.errorNotFullPrices && !multiPrice) {
      yield Effects.put(
        fireToastError(
          i18n.t('BED_4200_error_message_1'),
          15000,
          'Main',
          'ODPderivered',
          true,
          i18n.t('BED_4200_error_message_pricelist'),
          redirect(),
          settings(),
        ),
      )
      yield Effects.put({
        type: IntegrationAction.SetBookingPricingInfo,
        payload: 1,
      })

      yield Effects.put({
        type: IntegrationAction.SetBookingTab,
        payload: 0,
      })

      return false
    }

    if (items.errorEmptyPrices && !multiPrice) {
      yield Effects.put(
        fireToastError(
          i18n.t('BED_3197_price_tab_error_2'),
          15000,
          'Main',
          'emptyPrices',
        ),
      )
      yield Effects.put({
        type: IntegrationAction.SetBookingPricingInfo,
        payload: 1,
      })

      yield Effects.put({
        type: IntegrationAction.SetBookingTab,
        payload: 0,
      })

      return false
    }

    return true
  } catch (e) {
    //console.error(e)
  }
}

function* saveConfiguration(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SaveBookingMappings)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(actionNames.input, actionNames.output, saveBookingMappings),
      ),
    ])

    const mappings = yield Effects.select(getBookingMapping)
    const bookingSettings = yield Effects.select(getBookingSettings)
    // const user = yield Effects.select(getBookingUser)
    const userData = yield Effects.select(getUserProfile)
    const config = yield Effects.select(getPriceConfig)
    const rooms = yield Effects.select(getBookingRooms)
    const currencyList = yield Effects.select(getCurrency)
    const bookingRooms = yield Effects.select(withoutRemovedRooms)
    const currency = yield Effects.select(getBookingCurrency)
    const currencyUser = yield Effects.select(getUserCurrency)
    const multiPrice = yield Effects.select(getIsMultiPriceEnabled)

    if (currency && currency !== currencyUser) {
      yield Effects.put(fireToastError(i18n.t('BED_3197_price_tab_error_1')))
      return false
    }

    if (!config.displayed && !multiPrice) {
      yield Effects.put(fireToastError(i18n.t('BED_3197_price_tab_error_3')))
      return false
    }

    const pricing = yield Effects.select(getPrices)

    if (pricing.length === 0 && !multiPrice) {
      yield Effects.put(fireToastError(i18n.t('BED_3197_price_tab_error_2')))
      return false
    }

    if (config.pricePerPerson) {
      const roomPrices = pricing
        .reduce(
          (a, b) =>
            a.concat([
              ...b.prices.map(p => ({ ...p, roomId: String(b.roomId) })),
            ]),
          [],
        )
        .filter(Boolean)
        .filter(
          (p: any) =>
            (isBefore(p.from, new Date()) || isSameDay(p.from, new Date())) &&
            (isAfter(p.to, new Date()) || isSameDay(p.to, new Date())),
        )
        .map(r => ({
          ...r,
          roomSize: bookingRooms.find(br => String(br.id) === String(r.roomId))
            ? bookingRooms.find(br => String(br.id) === String(r.roomId))
                .roomSize
            : '0',
        }))

      const mappingRooms = mappings
        .map(r => r.bed_booking_rooms)
        .reduce((a, b) => a.concat(b), [])

      const p = roomPrices
        .filter(r => mappingRooms.includes(r.roomId))
        .every(
          p =>
            p.length === 0 ||
            Object.values(p.standard).length >= Number(p.roomSize),
        )

      if (!p && !multiPrice) {
        yield Effects.put(fireToastError(i18n.t('BED_3197_price_tab_error_4')))
        return false
      }
    }

    const roomsMapped = mappings.map(r => ({
      ...rooms.find(rm => rm.id === r.booking_id),
      ...r,
    }))

    const maps =
      roomsMapped &&
      roomsMapped.filter(
        m =>
          !!(
            rooms && rooms.find(r => r.id === m.booking_id && r.deleted !== '1')
          ),
      )

    const populatedRooms = roomsMapped.map(r => ({
      ...r,
      bed_booking_rooms: r.bed_booking_rooms.map(br =>
        bookingRooms.find(r => r.id === br),
      ),
    }))

    if (
      !(
        maps &&
        maps.filter(
          m => !!m.bed_booking_rooms && !!m.bed_booking_rooms.length,
        ) &&
        (
          maps.filter(
            m => !!m.bed_booking_rooms && !!m.bed_booking_rooms.length,
          ) || []
        ).length ===
          ((rooms && rooms.filter(r => r.deleted !== '1').length) || 0)
      )
    ) {
      yield Effects.put(fireToastError(i18n.t('BED_3197_mapping_tab_error_1')))
      return
    }

    if (
      populatedRooms.filter(
        p =>
          !p.bed_booking_rooms.every(
            r => String(r.roomSize) === String(p.fits),
          ),
      ).length
    ) {
      yield Effects.put({
        type: IntegrationAction.SetTrobuledBookingRooms,
        payload: populatedRooms.filter(
          p =>
            !p.bed_booking_rooms.every(
              r => String(r.roomSize) === String(p.fits),
            ),
        ),
      })
      yield Effects.put(fireToastError(i18n.t('BED_4197_error_text_1')))
      return
    }

    if (
      !multiPrice &&
      pricing &&
      pricing.every(p => p.restrictions.length === 0)
    ) {
      yield Effects.put(
        fireToastWarning(
          i18n.t('BED_3197_price_tab_error_6'),
          15000,
          'Main',
          'calculateListError2',
          true,
          i18n.t('BED_4200_error_message_pricelist'),
          redirect(),
          settings(),
        ),
      )
      yield Effects.put({
        type: IntegrationAction.SetBookingPricingInfo,
        payload: 2,
      })
      yield Effects.put({
        type: IntegrationAction.SetBookingTab,
        payload: 0,
      })
    }

    const validPrices = maps && maps.filter(m => m.prices.length === 0)

    if (
      validPrices.length === 0 ||
      bookingSettings.booking_integration_type === '1' ||
      multiPrice
    ) {
      const sucess = yield* validateBookingSaga({
        payload: bookingSettings.id,
      })
      if (sucess) {
        yield Effects.put(
          requestSaveObject(
            {
              ...userData,
              idCurrency: currencyList.find(item => item.name === currencyUser)
                .id,
            },
            true,
          ),
        )
        yield call(service, {
          mappings: mappings,
          settings: {
            ...bookingSettings,
            mappings: undefined,
            rooms: undefined,
            calendar_id: undefined,
          },
          // user: user,
        })
        if (!action.notNotify) {
          yield Effects.put(fireToastSuccess(i18n.t('user_settings_updated')))
          notifyIntegrationConfigSaved('booking', {
            idIntegration: bookingSettings.id,
          })
        }
        yield Effects.put({
          type: IntegrationAction.SetBookingPricingInfo,
          payload: 0,
        })
        if (action.redirect) {
          action.redirect()
        }
        return true
      } else {
        return false
      }
    } else {
      yield Effects.put(
        fireToastError(i18n.t('BED_3197_pricing_category_error_1')),
      )
      yield Effects.put({
        type: IntegrationAction.SetBookingErrorRooms,
        payload: validPrices,
      })
      return false
    }
  } catch (e) {
    //console.error(e)
  }
}

function* mergeBookingRatesAfterMapSaga(
  newRates: Record<string, number | string> = {},
  options?: { disableGlobal?: boolean },
) {
  const idObject = yield Effects.select(getUserObjectId)
  const calendarId = yield Effects.select(getCalendarId)
  const config = yield Effects.select(getPriceConfig)
  const accessToken = yield Effects.select(getAccessToken)
  if (
    !accessToken ||
    idObject == null ||
    calendarId == null ||
    !config ||
    !config.integrations
  ) {
    return
  }
  const bookingInt = config.integrations.booking
  const existingRates =
    bookingInt &&
    bookingInt.rates &&
    typeof bookingInt.rates === 'object' &&
    !Array.isArray(bookingInt.rates)
      ? { ...(bookingInt.rates as Record<string, string | number>) }
      : {}
  const merged: Record<string, string | number> = { ...existingRates }
  for (const [k, v] of Object.entries(newRates)) {
    // Liczbowe 0 = placeholder nowego planu niezależnego (ceny z Booking).
    if (typeof v === 'number' && v === 0) {
      merged[k] = 0
      continue
    }
    const n = normalizeBookingPlanRateValue(v)
    // Skonfigurowane 0% prowizji (z modala) → string "0".
    merged[k] = n === 0 ? '0' : n
  }
  const hasPerPlan =
    merged && typeof merged === 'object' && Object.keys(merged).length > 0
  const bookingPercent = hasPerPlan
    ? 0
    : Number(bookingInt && bookingInt.percent != null ? bookingInt.percent : 0)

  const fetchInstance = createFetch(accessToken)
  const postFee = updatePriceConfigurationFee({
    fetch: fetchInstance.authorizedFetch,
  })
  const airbnbInt = config.integrations.airbnb
  const dataToSave = {
    id_calendar: String(calendarId),
    id_object: idObject,
    integrations: {
      airbnb: {
        active: airbnbInt ? airbnbInt.active : false,
        percent: airbnbInt && airbnbInt.percent != null ? airbnbInt.percent : 0,
      },
      booking: {
        active: options?.disableGlobal
          ? false
          : bookingInt
          ? bookingInt.active
          : false,
        percent: bookingPercent,
        rates: merged,
      },
    },
  }
  yield Effects.call(postFee, dataToSave, String(idObject), String(calendarId))
  yield Effects.put({
    type: PriceConfigurationActions.RequestForConfiguration,
  })
}

function* mergeBookingPlanRatesSaga(action: any) {
  if (!action.payload || typeof action.payload !== 'object') {
    return
  }
  yield Effects.call(mergeBookingRatesAfterMapSaga, action.payload)
}

function* saveConfigurationImport(action: any) {
  try {
    const actionNames = fetchActionsName(ActionNames.SaveBookingMappingImport)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, saveMappingImport),
      ),
    ])

    const {
      new_booking_plan_rates: payloadPlanRates,
      price_import: priceImport,
      ...mapPayload
    } = action.payload

    yield Effects.call(service, {
      ...mapPayload,
      price_import: priceImport,
    })

    if (Number(priceImport) === 1) {
      const config = yield Effects.select(getPriceConfig)
      const globalRates = getConfiguredGlobalBookingPlanRates(
        config?.integrations?.booking,
      )
      if (globalRates && Object.keys(globalRates).length > 0) {
        yield Effects.call(
          mergeBookingRatesAfterMapSaga,
          globalRates,
          { disableGlobal: true },
        )
      }
      yield Effects.put({ type: 'FETCH_BOOKING_MULTI' })
    } else if (
      payloadPlanRates &&
      typeof payloadPlanRates === 'object' &&
      Object.keys(payloadPlanRates).length > 0
    ) {
      yield Effects.call(mergeBookingRatesAfterMapSaga, payloadPlanRates)
    }
  } catch (e) {
    if (e.message === '412') {
      yield Effects.put(requestSynchronization())
    }
    //console.error(e)
    yield Effects.put(
      fireToastError(
        i18n.t('error_server_response_2'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }
}

function* startRoomSync(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.StartBookingSyncingRooms)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, startBookingSync)),
    ])

    yield call(service, action.payload)
    yield Effects.put(
      fireToastSuccess(i18n.t('BED_3197_reservation_import_notfication')),
    )
  } catch (e) {
    //console.error(e)
  }
}

export default function*() {
  yield Effects.takeLatest(IntegrationAction.SetPropertyId, setPropertyId)
  // yield Effects.takeLatest(IntegrationAction.SetBookingStatus, setBookingStatus)
  yield Effects.throttle(
    2000,
    IntegrationAction.ConfirmBookingConfiguration,
    confirmBooking,
  )
  // yield Effects.takeLatest(
  //   IntegrationAction.UnconfirmBookingConfiguration,
  //   unconfirmBooking,
  // )
  yield Effects.takeLatest(
    IntegrationAction.FetchBookingSettings,
    getBookingSettingsSaga,
  )
  // yield Effects.takeLatest(
  //   IntegrationAction.FetchBookingRooms,
  //   getBookingRoomsSaga,
  // )
  // yield Effects.takeLatest(
  //   RoomActions.RequestDataForRooms,
  //   getBookingSettingsSaga,
  // )
  // yield Effects.takeLatest(RoomActions.RequestDataForRooms, getBookingRoomsSaga)
  yield Effects.takeLatest(
    IntegrationAction.BookingSaveConfiguration,
    saveConfiguration,
  )
  yield Effects.takeLatest(
    IntegrationAction.BookingStartRoomSync,
    startRoomSync,
  )
  yield Effects.takeLatest(
    IntegrationAction.BookingSaveMappedRoomsImport,
    saveConfigurationImport,
  )
  yield Effects.takeLatest(
    IntegrationAction.MergeBookingPlanRates,
    mergeBookingPlanRatesSaga,
  )
}
